import { render, staticRenderFns } from "./adminWorkDetailList.vue?vue&type=template&id=2ea35de8&scoped=true"
import script from "./adminWorkDetailList.vue?vue&type=script&lang=js"
export * from "./adminWorkDetailList.vue?vue&type=script&lang=js"
import style0 from "./adminWorkDetailList.vue?vue&type=style&index=0&id=2ea35de8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea35de8",
  null
  
)

export default component.exports